import "/__w/1/s/BotFramework-WebChat/packages/bundle/src/adaptiveCards/Attachment/AnimatedImageContent.module_built.css";
const classes = {"animated-image-content":"wkWVQnq_animated-image-content","animated-image-content__button":"wkWVQnq_animated-image-content__button","animated-image-content__overlay":"wkWVQnq_animated-image-content__overlay","animated-image-content__first-frame":"wkWVQnq_animated-image-content__first-frame","animated-image-content--paused":"wkWVQnq_animated-image-content--paused","animated-image-content__image":"wkWVQnq_animated-image-content__image"}
export default classes

const _animated_image_content0 = classes["animated-image-content"]
export { _animated_image_content0 as "animated-image-content" }

const _animated_image_content__button0 = classes["animated-image-content__button"]
export { _animated_image_content__button0 as "animated-image-content__button" }

const _animated_image_content__overlay0 = classes["animated-image-content__overlay"]
export { _animated_image_content__overlay0 as "animated-image-content__overlay" }

const _animated_image_content__first_frame0 = classes["animated-image-content__first-frame"]
export { _animated_image_content__first_frame0 as "animated-image-content__first-frame" }

const _animated_image_content__paused0 = classes["animated-image-content--paused"]
export { _animated_image_content__paused0 as "animated-image-content--paused" }

const _animated_image_content__image0 = classes["animated-image-content__image"]
export { _animated_image_content__image0 as "animated-image-content__image" }
